import { ExamsCredentials } from "./stores/app";

export const ExamCredentials: ExamsCredentials = {
  agora: { appId: "5ca93ee9f17047dd85afc9b1c8b7da0a" },
};
